import React, {useEffect, useState} from "react"
import { Box, Stack, Paper } from "@mui/material"
import {useDispatch, useSelector} from "react-redux";
import {clientActions} from "redux/clientSlice";
import {organizationState} from "redux/organizationSlice";
import CertificateCompliancePieChart from "./CertificateCompliancePieChart";
import VendorCompliancePieChart from "./VendorCompliancePieChart";
import InsuranceTypeDistributionPieChart from "./InsuranceTypeDistributionPieChart";
import {formatDate, subYears} from "date-fns";

const getStartDate = () => {
  const today = new Date()
  const fiveYearsLess = subYears(today, 5)
  const startDate = formatDate(fiveYearsLess, 'yyyy-MM-dd')
  return startDate
}

export default function DashboardHome() {
  const dispatch = useDispatch()
  const { selectedClient: client } = useSelector(organizationState)
  const [certificates, setCertificates] = useState([])
  const [clientVendors, setClientVendors] = useState([])
  async function getCertificates() {
    const filter = {
      certificateDate: {
        gt: getStartDate()
      }
    }
    const result = await dispatch(clientActions.listClientCertificates({
      filter,
      clientID: client.clientID
    }))
    const certs = []
    result?.payload?.certificates?.forEach(cert => {
      certs.push({
        ...cert,
        coverages: JSON.stringify(cert.coverages.items)
      })
    })
    setCertificates(certs)
  }

  async function getClientVendors() {
    const result = await dispatch(clientActions.listClientVendorsForClient({
      clientID: client.clientID,
      filter: {
        status: {
          ne: 'ARCHIVED'
        }
      }
    }))
    if(result?.payload?.clientVendors?.length) {
      setClientVendors(result.payload.clientVendors)
    }
  }

  useEffect(() => {
    if(client) {
      getCertificates()
      getClientVendors()
    }
  }, [client])

  return (
    <Box className="compliance-charts">
      <Stack direction="row" marginBottom={2} gap={2}>
        <Paper elevation={1} sx={{width: "50%"}}>
          <VendorCompliancePieChart client={client} clientVendors={clientVendors} />
        </Paper>
        <Paper elevation={1} sx={{width: "50%"}}>
          <CertificateCompliancePieChart certificates={certificates} />
        </Paper>
      </Stack>
      <Stack>
        <Paper elevation={1}>
          <InsuranceTypeDistributionPieChart certificates={certificates} />
        </Paper>
      </Stack>
    </Box>
  )
}
